import React from 'react';

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import { Accordion, AccordionDetails, AccordionSummary } from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

import makeClasses from './styles';
import { Utils } from '../../utils';

const InvoiceDetailsTable = ({ headers = [], body = [], i18n = {} }) => {
  const classes = makeClasses();

  const getRowCells = row => {
    const rowCells = [];
    for (let i = 0, l = headers.length; i < l; i += 1) {
      const cell = row.columns.find(col => col.id === headers[i].id);
      rowCells.push({
        label:
          cell.id === 'label'
            ? i18n.get(cell.value.substring(1, cell.value.length - 1))
            : `${cell.id} ${Utils.formatCurrency(cell.value)}`,
        alignment: cell.id === 'label' ? 'left' : 'right',
        className: cell.id === 'label' ? classes.rowInfo : classes.rowTotals,
      });
    }
    return rowCells;
  };

  const getCellWidth = cellIndex => {
    switch (cellIndex) {
      case 0:
        return '44%';
      case 1:
        return '30%';
      case 2:
        return '30%';
      default:
        return null;
    }
  };

  const renderTableRow = (row, index) => {
    const rowCells = getRowCells(row);

    if (row.rows.length > 0) {
      const rowRowsCells = row.rows.map(getRowCells);
      return (
        <TableRow key={index}>
          <TableCell colSpan={3} className={classes.accordionTableCellWrapper}>
            <Accordion className={classes.accordion}>
              <AccordionSummary className={classes.accordionSummary}>
                <Table>
                  <TableBody>
                    <TableRow>
                      {rowCells.map((cell, cellIndex) => (
                        <TableCell
                          key={cellIndex}
                          className={cell.className}
                          align={cell.alignment}
                          style={{ width: getCellWidth(cellIndex) }}
                        >
                          {cell.label}
                          {cellIndex === 0 ? <ExpandMoreIcon /> : null}
                        </TableCell>
                      ))}
                    </TableRow>
                  </TableBody>
                </Table>
              </AccordionSummary>
              <AccordionDetails className={classes.accordionDetails}>
                <Table>
                  <TableBody>
                    {rowRowsCells.map((row, rowIndex) => (
                      <TableRow key={rowIndex}>
                        {row.map((cell, cellIndex) => (
                          <TableCell
                            key={cellIndex}
                            className={cell.className}
                            align={cell.alignment}
                            style={{ width: getCellWidth(cellIndex) }}
                          >
                            {cell.label}
                          </TableCell>
                        ))}
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </AccordionDetails>
            </Accordion>
          </TableCell>
        </TableRow>
      );
    }

    return (
      <TableRow key={index}>
        {rowCells.map((cell, cellIndex) => (
          <TableCell key={cellIndex} className={cell.className} align={cell.alignment}>
            {cell.label}
          </TableCell>
        ))}
      </TableRow>
    );
  };

  return (
    <TableContainer component={Paper} elevation={3} className={classes.container}>
      <Table>
        <TableHead>
          <TableRow>
            {headers.map((header, index) => (
              <TableCell className={classes.header} key={index} align={index === 0 ? 'left' : 'right'}>
                {header.label}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>{body.map(renderTableRow)}</TableBody>
      </Table>
    </TableContainer>
  );
};

export default InvoiceDetailsTable;
